export const ALZHEIMER_DIAGNOSTIC_EVIDENCE = [
  {
    id: 'alz-association-2024-revised-criteria',
    citation: 'Jack CR Jr, et al. Revised criteria for diagnosis and staging of Alzheimer\'s disease: Alzheimer\'s Association Workgroup. Alzheimers Dement. 2024;20(8):5143-5169.',
    primarySource: { kind: 'doi', value: '10.1002/alz.13859' },
    usedBy: ['/diagnostica-alzheimer'],
    results: {
      biologicalDefinition: true,
      core1CanEstablishBiologicalAD: true,
      biologicalStageNotEqualClinicalSeverity: true,
      routineAsymptomaticBiomarkerAssessmentRecommended: false
    }
  },
  {
    id: 'detect-adrd-clinical-evaluation',
    citation: 'Atri A, Dickerson BC, et al. Alzheimer\'s Association clinical practice guideline for DETeCD-ADRD: executive summary for primary care. Alzheimers Dement. 2025;21:e14333.',
    primarySource: { kind: 'doi', value: '10.1002/alz.14333' },
    usedBy: ['/diagnostica-alzheimer'],
    results: {
      symptomaticEvaluation: true,
      includesHistoryAndInformant: true,
      characterizesCognitiveFunctionalStatus: true,
      characterizesCognitiveBehavioralSyndrome: true,
      investigatesUnderlyingDisease: true
    }
  },
  {
    id: 'nice-ng97-dementia-assessment',
    citation: 'National Institute for Health and Care Excellence. Dementia: assessment, management and support for people living with dementia and their carers. NG97.',
    primarySource: { kind: 'journal-url', value: 'https://www.nice.org.uk/guidance/ng97/chapter/recommendations' },
    usedBy: ['/diagnostica-alzheimer'],
    results: {
      normalBriefCognitiveScoreDoesNotRuleOutDementia: true,
      investigateContributingOrReversibleCauses: true,
      structuralImagingWhenAppropriate: true,
      neuropsychologyWhenUnclear: true
    }
  }
];

export function getAlzheimerDiagnosticEvidenceById(id) {
  return ALZHEIMER_DIAGNOSTIC_EVIDENCE.find((item) => item.id === id);
}
